import { useHasMounted } from './use-has-mounted';

/**
 * Use this hook instead of `useSearchParams` to avoid opting into client-side rendering
 */
export function useQueryParams(key: string) {
  const getValue = () => {
    const url = new URL(window.location.href);
    return url.searchParams.get(key) || null;
  };
  const mounted = useHasMounted();
  return mounted ? getValue() : null;
}
